
const { apiUrl, nonce, root } = wooSyncSettings;

const commonHeaders = new Headers({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'X-WP-Nonce': nonce,
});

function get(endpoint, params = null) {
    const url = new URL(`${apiUrl}/${endpoint}`);

    if (params) {
        Object.keys(params).forEach(key => (params[key] === null) && delete params[key]);
        url.search = new URLSearchParams(params);
    }

    return fetch(url, { headers: commonHeaders }).then(res => res.json());
}

function post(endpoint, body) {
    const request = new Request(`${apiUrl}/${endpoint}`, { 
        method: 'POST', 
        body: JSON.stringify(body),
        headers: commonHeaders 
    });

    return fetch(request).then(res => {
        if (res.ok) {
            return res.json();
        } else {
            return res.json().then(res => Promise.reject(new Error(res.message)));
        }
    });
}

const api = { get, post };

export default api;
